export default __webpack_public_path__ + "static/product-bar-bisolduo-sprey-7b499238dd661861b9144fc3aa32f7db.png";